import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { defaultColors } from '../../../styles/style-guide';
import { CustomInputContainer, ErrorMessage, Input, LabelContainer } from './styleGuide';
import { CustomTooltip } from '../../atoms';
import { useAppSelector } from '../../../hooks/hooksRedux';
import { RootState } from '../../../store';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  id: string;
  label: string;
  error?: string;
  placeholder?: string;
  tooltip?: string;
  leftTooltip?: string;
  register: UseFormRegister<any>;
}

const CustomInput = ({ id, label, error, placeholder, register, tooltip, leftTooltip, ...rest }: Props) => {
  const colors = useAppSelector((state: RootState) => state.styleGuide.data.colors);
  const primaryColor = colors.primary || defaultColors.primary;
  const colorError = '#ef4444';

  return (
    <CustomInputContainer>
      <div className="flex">
        <LabelContainer $color={error ? colorError : primaryColor}>
          {leftTooltip && <CustomTooltip content={leftTooltip} />}
          {label}
        </LabelContainer>
        {tooltip && <CustomTooltip content={tooltip} />}
      </div>
      <Input
        $hasError={!!error}
        $borderColor={primaryColor}
        $focusColor="#1d4ed8"
        $errorColor="#ef4444"
        {...register(id)}
        {...rest}
        placeholder={placeholder}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </CustomInputContainer>
  );
};

export { CustomInput };
